import React, { useState } from "react";
import "./styles.css";
import DownArrow from "../IconComponents/DownArrow";
import PropTypes from "prop-types";

export default function Accordion({
    iconComponent: IconComponent,
    title,
    children,
}) {
    const [isActive, setIsActive] = useState(false);

    function handleAccordionClick(e) {
        e.stopPropagation();
        setIsActive(!isActive);
    }

    return (
        <div className="accordion-container rounded-lg shadow-[0px_0px_5px_0px_rgba(0,0,0,0.1)]">
            <div className="accordion-header" onClick={handleAccordionClick}>
                <div className="accordion-logo-title">
                    <div>{IconComponent && <IconComponent />}</div>
                    <div className="text-primary-500 text-[22px]">{title}</div>
                </div>
                {isActive ? (
                    <DownArrow className="accordion-arrow-up" />
                ) : (
                    <DownArrow className="click-outside-ignore" />
                )}
            </div>
            {isActive && (
                <div
                    className="accordion-content click-outside-ignore"
                    onClick={handleAccordionClick}
                >
                    {children}
                </div>
            )}
        </div>
    );
}

Accordion.propTypes = {
    iconComponent: PropTypes.elementType,
    title: PropTypes.string,
    children: PropTypes.node,
};
